import React, { useState, useCallback } from 'react';
import * as Sentry from '@sentry/browser';
import { useNavigate } from 'react-router';
import axios from 'axios';

import i18n from '@/settings/i18n';
import { pages } from '@/settings/pages';
import { adminApi } from '@/services/api';
import { useCapyValues } from '@/hooks/useCapyValues';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';

import { RemindForm, Values } from '../Presentation';

export const RemindFormContainer: React.FC = () => {
  const { flashError } = useFlashMessenger();
  const [isLoading, setIsLoading] = useState(false);
  const [capyError, setCapyError] = useState(false);
  const { setCapyValues, createParamsWithCapyValues } = useCapyValues();

  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (values: Values) => {
      try {
        setIsLoading(true);
        setCapyError(false);
        const data = createParamsWithCapyValues(values);
        await adminApi.sendVerificationMail({ data });
        navigate(pages.token.sent);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response !== undefined) {
          if (err.response && err.response.status === 401) {
            setCapyError(true);
          } else {
            Sentry.captureException(err);

            flashError(i18n.t('ui.error.unexpected'));
          }
          setIsLoading(false);
        }
      }
    },
    [createParamsWithCapyValues, flashError, navigate],
  );

  const childProps = { isLoading, capyError, onSubmit, setCapyValues };
  return <RemindForm {...childProps} />;
};
